import React, { useState, useMemo } from 'react';
import { Container, ThisCard } from './styles';

import LogoAnalistaAtivo from '~/assets/icones/LogoAnalistaAtivo.svg';
import LogoAnalistaAtivoB from '~/assets/icones/LogoAnalistaAtivoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  const { analistasComMoviDesk, analistasSemMoviDesk } = useMemo(() => {
    if (!data || !Array.isArray(data)) {
      return { analistasComMoviDesk: [], analistasSemMoviDesk: [] };
    }

    const comMoviDesk = data.filter(
      analista => analista.idMoviDesk && analista.idMoviDesk !== null,
    );
    const semMoviDesk = data.filter(
      analista => !analista.idMoviDesk || analista.idMoviDesk === null,
    );

    return {
      analistasComMoviDesk: comMoviDesk,
      analistasSemMoviDesk: semMoviDesk,
    };
  }, [data]);

  const renderAnalistas = (analistas, titulo) => (
    <div style={{ marginBottom: '2rem' }}>
      <h3
        style={{
          marginBottom: '1rem',
          // color: localStorage.getItem('tema') == 'E' ? '#333' : '#666',
          fontSize: '1.2rem',
          fontWeight: '600',
        }}
      >
        {titulo} ({analistas.length})
      </h3>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {analistas.map((thisData, i) => (
          <ThisCard
            className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
            {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
            key={thisData?.id || i}
            id={thisData?.id || i}
            index={i}
            ativo={linhaAtiva === thisData?.id ? true : false}
            style={{ marginBottom: '1rem' }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="card-text">
                  <p className="descricao">#{thisData?.codigo}</p>
                  <p className="titulo">{thisData?.nome}</p>
                  <p className="descricao-cord">Coord.: {thisData?.coordenador?.nome}</p>
                  {thisData?.idMoviDesk && (
                    <p className="descricao" style={{ color: '#28a745', fontSize: '0.8rem' }}>
                      MoviDesk: {thisData?.idMoviDesk}
                    </p>
                  )}
                </div>
              </div>
              <div className="card">
                <img
                  src={localStorage.getItem('tema') == 'E' ? LogoAnalistaAtivo : LogoAnalistaAtivoB}
                  alt="Vazio"
                />
              </div>
            </div>
            <div className="card-bottom">
              {thisData?.produtos?.map((thisProduto, o) => (
                <div className="card-grupo" key={o}>
                  <p className="grupoperfil">{thisProduto?.produto?.titulo}</p>
                </div>
              ))}
            </div>
          </ThisCard>
        ))}
      </div>
    </div>
  );

  return (
    <Container>
      {renderAnalistas(analistasComMoviDesk, 'Analistas de Suporte')}
      {renderAnalistas(analistasSemMoviDesk, 'Analistas de Projeto')}
    </Container>
  );
}

export default CustomBodyContent;
